'use client'

import { TProduct } from '@/features/catalog/config'
import { Product } from '@/redux/services/catalogApi'
import Image from 'next/image'
import Link from 'next/link'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export interface ProductItem {
    id: number
    title: string
    image: string
    type: number[]
    animal_type: number[]
    feeding_type: number[]
    animal_age: number[]
    animal_needs: number[]
    subtitle: string
    volume: number
    expiration_date: string
    description: string
    necessary_list: string[]
    composition_id: number[]
    application: string
    application_values: number[]
    gallery: string[]
    videos: number[]
}

interface Tag {
    id: number
    title: string
    value: string
}

type ProductProps = {
    item: Product | any
    tag?: Tag
    linked?: Boolean
    vacancyCard?: Boolean
    type?: string
}

const CatalogProdCardV2: React.FC<{ product: any }> = ({ product }) => {
    const [hoverOn, setHoverOn] = React.useState(false)
    const { t } = useTranslation()

    const lineOnHover = () => {
        setHoverOn(true)
    }

    const lineOffHover = () => {
        setHoverOn(false)
    }

    const getTag = useCallback(() => {
        let res = t('moreDetailedTest')
        if (product && !hoverOn) {
            if (product?.region && product?.region[0] && product?.region[0]?.title) {
                res = product?.region[0]?.title
            } else if (product?.type && product?.type[0] && product?.type[0]?.title) {
                res = product?.type[0]?.title
            }
        }
        return res
    }, [product, hoverOn])

    return (
        <>
            <Link
                href={
                    product &&
                    `/catalog/${product?.type && product?.type && product?.type[0]?.value ? product.type[0].value : 'some-category'}/${product?.animal_type && product?.animal_type[0]?.translit ? product?.animal_type[0]?.translit : 'some-category'}/${product.translit}`
                }
            >
                <li
                    onMouseEnter={lineOnHover}
                    onMouseLeave={lineOffHover}
                    className='catalog__product'
                >
                    <div className='catalog__product-title'>
                        <h3>{product.title}</h3>
                        {/* {type === 'materials-products' && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.8457 10.3906H10.4395V11.7969H11.8457V10.3906Z" fill="#A9B4D1" />
                                <path d="M2.10337 15.0938L7.34723 11.3604V11.2212C7.34723 10.0644 7.91597 8.98205 8.8687 8.32584L10.386 7.28077C10.5756 5.91286 11.7526 4.8562 13.1718 4.8562H13.854C13.6083 3.57577 13.9686 2.20472 14.9405 1.21838C15.7105 0.436781 16.7387 0.00407813 17.8355 4.6875e-05C17.8407 0 17.8459 0 17.8511 0C18.9421 0 19.9673 0.424547 20.7392 1.19648L19.7449 2.19084C19.4222 1.8682 18.8924 1.863 18.564 2.17913C18.4057 2.33138 18.3175 2.54077 18.3153 2.76877C18.313 3.00684 18.4072 3.23883 18.5736 3.40533L20.034 4.86572C20.7834 5.61506 20.9649 6.72 20.5795 7.64217H24V10.0921C24 11.1544 23.5257 12.1074 22.7786 12.7526L24 14.2059V24H11.9536C10.8002 24 9.675 23.7762 8.6093 23.3348C7.54364 22.8934 6.58973 22.256 5.77411 21.4403L5.52127 21.1875H3.51562C1.57711 21.1875 0 19.6104 0 17.6719V17.2031C0 16.042 0.942984 15.097 2.10337 15.0938ZM19.0397 5.86008L17.5793 4.39969C17.1475 3.96797 16.9032 3.36858 16.9091 2.75536C16.9137 2.27817 17.0631 1.82812 17.3357 1.45542C16.8097 1.55728 16.3268 1.81495 15.9422 2.20538C14.9134 3.24952 14.9333 4.95591 15.9866 6.00919L17.4386 7.46123C17.8749 7.89755 18.6033 7.89759 19.0397 7.46123C19.476 7.02478 19.476 6.29648 19.0397 5.86008ZM11.9536 22.5938H22.5938V14.7184L21.5275 13.4497C21.1978 13.5524 20.8474 13.6078 20.4844 13.6078H20.0281V16.2656C20.0281 18.9795 17.8201 21.1875 15.1062 21.1875H7.63355C8.88037 22.1004 10.379 22.5938 11.9536 22.5938ZM1.40625 17.6719C1.40625 18.835 2.35252 19.7812 3.51562 19.7812H15.1062C17.0447 19.7812 18.6218 18.2041 18.6218 16.2656V13.6077H18.1406V12.2015H20.4844C21.6475 12.2015 22.5938 11.2552 22.5938 10.0921V9.04838H19.7344C18.5713 9.04838 17.625 9.99464 17.625 11.1578H16.2188C16.2188 10.299 16.5287 9.51155 17.042 8.9003C16.8247 8.78381 16.6234 8.63475 16.4442 8.4555L14.9922 7.0035C14.7638 6.77508 14.5687 6.52575 14.4047 6.26241H13.1717C12.3964 6.26241 11.7656 6.8932 11.7656 7.66856V8.03803L9.66628 9.48394C9.09469 9.87764 8.75339 10.5271 8.75339 11.2212V12.0855L2.55281 16.5H2.10938C1.72167 16.5 1.40625 16.8154 1.40625 17.2031V17.6719Z" fill="#A9B4D1" />
                                <path d="M4.3125 16.4531H5.71875C5.71875 17.6162 4.77248 18.5625 3.60938 18.5625V17.1562C3.99708 17.1562 4.3125 16.8408 4.3125 16.4531Z" fill="#A9B4D1" />
                            </svg>} */}
                    </div>
                    <Image
                        src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${product.image}`}
                        width={403}
                        height={346}
                        alt='card-image'
                    />
                    <p className='categories-slider__text'>{getTag()}</p>
                </li>
            </Link>
        </>
    )
}

export default CatalogProdCardV2
